import React, { useState } from "react";
import "./permission.css";
import SearchIcon from "@mui/icons-material/Search";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Checkbox,
  TextField,
} from "@mui/material";
import { Button } from "react-bootstrap";
import axios from "axios";
import { HOST_URL, LOCAL_STORAGE_KEY } from "../../../config";
import { path } from "../../../order_managment/constants/apiPath";
import { NotificationManager } from "react-notifications";
import ShipmentReportCo2 from "../shipments/ShipmentReportCo2";

function Permission() {
  const [searchEmail, setSearchEmail] = useState("");
  const [permission, setPermission] = useState({
    EmailId: "",
    POrder: false,
    OrderDashBoard: false,
    CreateOrder: false,
    OrderList: false,
    OrderLog: false,
    OrderReport: false,
    Shipment: false,
    ShipmentDashBoard: false,
    ShipmentList: false,
    ShipmentAnalytics: false,
    ShipmentReport: false,
    // ShipmentReportCo2: false,
    ShipmentMap: false,
    ShipmentMilstone: false,
    ShipmentDetail: false,
    ShipmentDocument: false,
    ShipmentContainer: false,
    Finance: false,
    StatementOfAccount: false,
    Schedule: false,
    ScheduleSearch: false,
    CargoInsurance: false,
    // cargoInsurancePermisionCollection:null
    Rms: false,
    RmsLcl: false,
    RmsFcl: false,
    adminSetting: false,
    adminSettingCreateUser: false,
    adminSettingGrantPermission: false,
    adminSettingUpdatePermission: false,
    adminSettingViewPermission: false,
  });

  const handleCheckboxChange  = (field) => {
    setPermission((prev) => {
      const updatedPermission = { ...prev, [field]: !prev[field] };
      if (field === "adminSetting") {
        updatedPermission.adminSettingCreateUser = !prev.adminSetting;
        updatedPermission.adminSettingGrantPermission = !prev.adminSetting;
        updatedPermission.adminSettingUpdatePermission = !prev.adminSetting;
        updatedPermission.adminSettingViewPermission = !prev.adminSetting;
      }
      else if(field === "POrder") {
        updatedPermission.OrderDashBoard = !prev.POrder;
        updatedPermission.CreateOrder = !prev.POrder;
        updatedPermission.OrderList = !prev.POrder;
        updatedPermission.OrderLog = !prev.POrder;
        updatedPermission.OrderReport = !prev.POrder;
      }
      else if(field === "Shipment") {
        updatedPermission.ShipmentDashBoard = !prev.Shipment;
        updatedPermission.ShipmentList = !prev.Shipment;
        updatedPermission.ShipmentAnalytics = !prev.Shipment;
        updatedPermission.ShipmentReport = !prev.Shipment;
        updatedPermission.ShipmentMap = !prev.Shipment;
        updatedPermission.ShipmentMilstone = !prev.Shipment;
        updatedPermission.ShipmentDetail = !prev.Shipment;
        updatedPermission.ShipmentDocument = !prev.Shipment;
        updatedPermission.ShipmentContainer = !prev.Shipment;
      }
      else if(field === "Finance") {
        updatedPermission.StatementOfAccount = !prev.Finance;
       
      }
      else if(field === "Schedule") {
        updatedPermission.ScheduleSearch = !prev.Schedule;
        
      }
      else if(field === "Rms") {
        updatedPermission.RmsLcl = !prev.Rms;
        updatedPermission.RmsFcl = !prev.Rms;
    
      }
      else if(field === "CargoInsurance") {
         
      }
      return updatedPermission;
    });
  };

  const createPermissions = async () => {
    let data = await JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
    );
    const headers = {
      UserName: data?.user_name,
      UserSecret: data?.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    axios
      .post(`${HOST_URL}${path.CREATEPERMISSION}`, permission, { headers })
      .then((res) => {
        NotificationManager.success(res?.data?.message, "", 3000);
        // handleClearSearch()
      })
      .catch((err) => {
        console.log(err);
        NotificationManager.error(err?.data?.message, "", 3000);
      });
  };

  const updatePermissions = async () => {
    let data = await JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
    );
    const headers = {
      UserName: data?.user_name,
      UserSecret: data?.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    axios
      .put(`${HOST_URL}${path.UPDATEPERMISSION}`, permission, { headers })
      .then((res) => {
        NotificationManager.success(res?.data?.message, "", 1000);
       
      })
      .catch((err) => {
        console.log(err);
        NotificationManager.error(err?.data?.message, "", 3000);
      });
  };

  const fetchPermissions = async () => {
    let data = await JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
    );

    axios
      .get(`${HOST_URL}${path.GETPERMISSION}`, {
        params: { emailId: searchEmail },
        headers: {
          UserName: data?.user_name,
          UserSecret: data?.password,
          DeviceType: "W",
          MacAddress: "",
          IPAddress: "",
        },
      })
      .then((res) => {
        const permissionData = res?.data?.data;
        setPermission({
          EmailId: "",
          adminSetting: permissionData?.adminSetting,
          POrder: permissionData?.order,
          Shipment: permissionData?.shipment,
          Finance: permissionData?.finance,
          Schedule: permissionData?.schedule,
          CargoInsurance: permissionData?.cargoInsurance,
          Rms: permissionData?.rms,
          adminSettingCreateUser:
            permissionData?.adminSettings?.adminSettingCreateUser,
          adminSettingGrantPermission:
            permissionData?.adminSettings?.adminSettingGrantPermission,
          adminSettingUpdatePermission:
            permissionData?.adminSettings?.adminSettingUpdatePermission,
          adminSettingViewPermission:
            permissionData?.adminSettings?.adminSettingViewPermission,
            OrderDashBoard:
            permissionData?.orderPermisionCollection?.orderDashBoard,
            CreateOrder: permissionData?.orderPermisionCollection?.createOrder,
            OrderList: permissionData?.orderPermisionCollection?.orderList,
            OrderLog: permissionData?.orderPermisionCollection?.orderLog,
            OrderReport: permissionData?.orderPermisionCollection?.orderReport,
            ShipmentDashBoard:
            permissionData?.shipmentPermisionCollection?.shipmentDashBoard,
            ShipmentList: permissionData?.shipmentPermisionCollection?.shipmentList,
            ShipmentAnalytics:
            permissionData?.shipmentPermisionCollection?.shipmentAnalytics,
            ShipmentReport:
            permissionData?.shipmentPermisionCollection?.shipmentReport,
            ShipmentMap: permissionData?.shipmentPermisionCollection?.shipmentMap,
            ShipmentMilstone:
            permissionData?.shipmentPermisionCollection?.shipmentMilstone,
            ShipmentDetail:
            permissionData?.shipmentPermisionCollection?.shipmentDetail,
            ShipmentDocument:
            permissionData?.shipmentPermisionCollection?.shipmentDocument,
            ShipmentContainer:
            permissionData?.shipmentPermisionCollection?.shipmentContainer,

            StatementOfAccount:
            permissionData?.financePermisionCollection?.statementOfAccount,
            RmsLcl: permissionData?.rmsPermisionCollection?.rmsLcl,
            RmsFcl: permissionData?.rmsPermisionCollection?.rmsFcl,
          ScheduleSearch:
            permissionData?.schedulePermisionCollection?.scheduleSearch,
        });
      })
      .catch((err) => {
        console.error("API Error:", err.response.data);
      });
  };

  const handleSearch = () => {
    fetchPermissions();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      fetchPermissions();
    }
  };


  const handleClearSearch = () => {
    setSearchEmail("");
    setPermission({
      EmailId: "",
      POrder: false,
      OrderDashBoard: false,
      CreateOrder: false,
      OrderList: false,
      OrderLog: false,
      OrderReport: false,
      Shipment: false,
      ShipmentDashBoard: false,
      ShipmentList: false,
      ShipmentAnalytics: false,
      ShipmentReport: false,
      ShipmentMap: false,
      ShipmentMilstone: false,
      ShipmentDetail: false,
      ShipmentDocument: false,
      ShipmentContainer: false,
      Finance: false,
      StatementOfAccount: false,
      Schedule: false,
      ScheduleSearch: false,
      CargoInsurance: false,
      Rms: false,
      RmsLcl: false,
      RmsFcl: false,
      adminSetting: false,
      adminSettingCreateUser: false,
      adminSettingGrantPermission: false,
      adminSettingUpdatePermission: false,
      adminSettingViewPermission: false,
    });
  };

  return (
    <Grid container className="flex-row" spacing={1}>
      <Grid item lg={6} className="d-flex align-items-center">
        <h5 className="head-color mb-0 me-2">Email* : </h5>
        <TextField
          label="User Id *"
          id="outlined-size-normal"
          defaultValue=""
          size="small"
          value={permission?.EmailId ?? ""}
          onChange={(e) =>
            setPermission({ ...permission, EmailId: e.target.value })
          }
        />
      </Grid>
      <Grid item lg={6} className="d-flex">
        <div className="headersearch">
          <input
            type="text"
            className="form-control"
            placeholder={"     Search"}
            value={searchEmail}
            onChange={(e) => setSearchEmail(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <SearchIcon
            style={{
              position: "absolute",
              left: "0.5rem",
              cursor: "pointer",
            }}
            onClick={handleSearch}
          />
          <CloseOutlinedIcon
            style={{
              position: "absolute",
              right: "1rem",
              cursor: "pointer",
            }}
            className="searchClearIcon"
            onClick={handleClearSearch}
          />
        </div>
      </Grid>

      <Grid item lg={12} className="add_check">
        <FormControl>
          <FormControlLabel
            control={
              <Checkbox
                checked={permission?.adminSetting}
                onChange={() => handleCheckboxChange("adminSetting")}
              />
            }
            label={<h5 className="head-color m-0">Admin Setting </h5>}
          />
          <FormLabel>
            <p className="mb-0 mt-2">Permission :</p>
          </FormLabel>
          <div className="d-flex check">
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.adminSettingCreateUser}
                  onChange={() =>
                    handleCheckboxChange("adminSettingCreateUser")
                  }
                />
              }
              label="Create User"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.adminSettingGrantPermission}
                  onChange={() =>
                    handleCheckboxChange("adminSettingGrantPermission")
                  }
                />
              }
              label="Grant Permission"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.adminSettingUpdatePermission}
                  onChange={() =>
                    handleCheckboxChange("adminSettingUpdatePermission")
                  }
                />
              }
              label="Update Permission"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.adminSettingViewPermission}
                  onChange={() =>
                    handleCheckboxChange("adminSettingViewPermission")
                  }
                />
              }
              label="View Permission"
            />
          </div>
        </FormControl>
      </Grid>
      <Grid item lg={12} className="add_check">
        <FormControl>
          <FormControlLabel
            control={
              <Checkbox
                checked={permission?.POrder}
                onChange={() => handleCheckboxChange("POrder")}
              />
            }
            label={<h5 className="head-color m-0">Order </h5>}
          />
          <FormLabel>
            <p className="mb-0 mt-2">Permission :</p>
          </FormLabel>
          <div className="d-flex check">
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.OrderDashBoard}
                  onChange={() => handleCheckboxChange("OrderDashBoard")}
                />
              }
              label="Order DashBoard"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.CreateOrder}
                  onChange={() => handleCheckboxChange("CreateOrder")}
                />
              }
              label="Create Order"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.OrderList}
                  onChange={() => handleCheckboxChange("OrderList")}
                />
              }
              label="Order List"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.OrderLog}
                  onChange={() => handleCheckboxChange("OrderLog")}
                />
              }
              label="Order Log"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.OrderReport}
                  onChange={() => handleCheckboxChange("OrderReport")}
                />
              }
              label="Order Report"
            />
          </div>
        </FormControl>
      </Grid>
      <Grid item lg={12} className="add_check">
        <FormControl>
          <FormControlLabel
            control={
              <Checkbox
                checked={permission?.Shipment}
                onChange={() => handleCheckboxChange("Shipment")}
              />
            }
            label={<h5 className="head-color m-0">Shipment </h5>}
          />
          <FormLabel>
            <p className="mb-0 mt-2">Permission :</p>
          </FormLabel>
          <div className="d-flex check flex-wrap">
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.ShipmentDashBoard}
                  onChange={() => handleCheckboxChange("ShipmentDashBoard")}
                />
              }
              label="Shipment DashBoard"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.ShipmentList}
                  onChange={() => handleCheckboxChange("ShipmentList")}
                />
              }
              label="Shipment List"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.ShipmentAnalytics}
                  onChange={() => handleCheckboxChange("ShipmentAnalytics")}
                />
              }
              label="Shipment Analytics"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.ShipmentReport}
                  onChange={() => handleCheckboxChange("ShipmentReport")}
                />
              }
              label="Shipment Report"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.ShipmentMap}
                  onChange={() => handleCheckboxChange("ShipmentMap")}
                />
              }
              label="Shipment Map"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.ShipmentMilstone}
                  onChange={() => handleCheckboxChange("ShipmentMilstone")}
                />
              }
              label="Shipment Milestone"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.ShipmentDetail}
                  onChange={() => handleCheckboxChange("ShipmentDetail")}
                />
              }
              label="Shipment Detail"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.ShipmentDocument}
                  onChange={() => handleCheckboxChange("ShipmentDocument")}
                />
              }
              label="Shipment Document"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.ShipmentContainer}
                  onChange={() => handleCheckboxChange("ShipmentContainer")}
                />
              }
              label="Shipment Container"
            />
          </div>
        </FormControl>
      </Grid>
      <Grid item lg={12} className="add_check">
        <FormControl>
          <FormControlLabel
            control={
              <Checkbox
                checked={permission?.Finance}
                onChange={() => handleCheckboxChange("Finance")}
              />
            }
            label={<h5 className="head-color m-0">Finance </h5>}
          />
          <FormLabel>
            <p className="mb-0 mt-2">Permission :</p>
          </FormLabel>
          <div className="d-flex check">
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.StatementOfAccount}
                  onChange={() => handleCheckboxChange("StatementOfAccount")}
                />
              }
              label="Statement Of Account"
            />
          </div>
        </FormControl>
      </Grid>
      <Grid item lg={12} className="add_check">
        <FormControl>
          <FormControlLabel
            control={
              <Checkbox
                checked={permission?.Schedule}
                onChange={() => handleCheckboxChange("Schedule")}
              />
            }
            label={<h5 className="head-color m-0">Schedule </h5>}
          />
          <FormLabel>
            <p className="mb-0 mt-2">Permission :</p>
          </FormLabel>
          <div className="d-flex check">
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.ScheduleSearch}
                  onChange={() => handleCheckboxChange("ScheduleSearch")}
                />
              }
              label="Schedule Search"
            />
          </div>
        </FormControl>
      </Grid>
      
      <Grid item lg={12} className="add_check">
        <FormControl>
          <FormControlLabel
            control={
              <Checkbox
                checked={permission?.Rms}
                onChange={() => handleCheckboxChange("Rms")}
              />
            }
            label={<h5 className="head-color m-0">RMS</h5>}
          />
          <FormLabel>
            <p className="mb-0 mt-2">Permission :</p>
          </FormLabel>
          <div className="d-flex check">
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.RmsLcl}
                  onChange={() => handleCheckboxChange("RmsLcl")}
                />
              }
              label="Rms LCL"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={permission?.RmsFcl}
                  onChange={() => handleCheckboxChange("RmsFcl")}
                />
              }
              label="Rms FCL"
            />
          </div>
        </FormControl>
      </Grid>
      <Grid item lg={12} className="add_check">
      <FormControl>
          <FormControlLabel
            control={
              <Checkbox
                checked={permission?.CargoInsurance}
                onChange={() => handleCheckboxChange("CargoInsurance")}
              />
            }
            label={<h5 className="head-color m-0">Cargo Insurance</h5>}
          />
          {/* <FormLabel>
            <p className="mb-0 mt-2">Permission :</p>
          </FormLabel>
          <div className="d-flex check">
            <FormControlLabel
              control={
                <Checkbox
                 
                />
              }
              label=""
            />
            <FormControlLabel
              control={
                <Checkbox
                  
                />
              }
              label=""
            />
          </div> */}
        </FormControl>
        
      </Grid>
      <Grid item lg={12} className="d-flex justify-content-center align-items-center">
        <Button onClick={createPermissions} className="me-3">
          Create
        </Button>
        <Button onClick={updatePermissions}>Update</Button>
      </Grid>
    </Grid>
  );
}

export default Permission;
